module.exports = __webpack_public_path__ + "c7ab6bffad791ad17e5bcd36b3fa1300.png";